import { useEffect } from "react";

/**
 * Sets absolute Open Graph / Twitter image URLs from the live origin so link
 * previews (Slack, iMessage, WhatsApp, etc.) resolve the logo correctly.
 */
export default function SeoMeta() {
    useEffect(() => {
        const origin = window.location.origin;
        const path = window.location.pathname || "/";
        const pub = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
        /** CRA `homepage` as full URL makes `PUBLIC_URL` absolute — do not prepend `origin` twice. */
        const imageUrl =
            pub.startsWith("http://") || pub.startsWith("https://")
                ? `${pub}/brand-icon.png`
                : pub
                  ? `${origin}${pub}/brand-icon.png`
                  : `${origin}/brand-icon.png`;
        const pageUrl = `${origin}${path}`;

        const upsert = (selector, attrName, attrValue, content) => {
            let el = document.head.querySelector(selector);
            if (!el) {
                el = document.createElement("meta");
                el.setAttribute(attrName, attrValue);
                document.head.appendChild(el);
            }
            el.setAttribute("content", content);
        };

        upsert(
            'meta[property="og:image"]',
            "property",
            "og:image",
            imageUrl,
        );
        upsert('meta[property="og:url"]', "property", "og:url", pageUrl);
        upsert(
            'meta[name="twitter:image"]',
            "name",
            "twitter:image",
            imageUrl,
        );
    }, []);

    return null;
}
